var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "500",
        "content-class": "popular-parlays-dialog",
        persistent: ""
      },
      model: {
        value: _vm.popularParlaysData,
        callback: function($$v) {
          _vm.popularParlaysData = $$v
        },
        expression: "popularParlaysData"
      }
    },
    [
      _c("div", { staticClass: "close-btn" }, [
        _c("button", {
          staticClass: "close",
          domProps: { innerHTML: _vm._s(_vm.$t("Popular.Parlays.Close")) },
          on: { click: _vm.closePopularParlaysDialog }
        })
      ]),
      _vm._v(" "),
      _vm.popularParlaysData &&
      _vm.popularParlay &&
      _vm.popularParlay.SelectionData
        ? _c(
            "v-card",
            {
              key: _vm.popularParlay.IDFWMarketGroup,
              staticClass: "recomended-parlays",
              attrs: { "data-mgid": _vm.popularParlay.IDFWMarketGroup }
            },
            [_c("popular-parlay", { attrs: { parlays: _vm.popularParlay } })],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04e3d135", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04e3d135","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/popularParlays/PopularParlaysDialog.vue
// module id = null
// module chunks = 